








































import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { getAllClass, removeStudent } from './student.api'

@Component
export default class StudentRemove extends ViewBase {
  @Prop({ type: Object, default: () => ({}) }) item!: object
  @Prop({ type: Boolean, default: true }) visible!: boolean
  @Prop({ type: Number, default: 0 }) classId!: number

  labelCol = { span: 24 }
  wrapperCol = { span: 24 }
  lang = {}
  isEdit = false
  svisible = false
  doc: any
  classChoice: any = null
  classList: object = []
  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  classChange(val: any) {
    this.classChoice = val
  }

  created() {
    this.doc = window.document
    this.lang = this.i18n.vBinding
    this.getAllClass()
    const lang: any = this.lang
  }

  @Watch('visible')
  watchVisible(visible: any) {
    this.svisible = visible
    const item: any = this.item
    if (item) {
      this.classChoice = item.class_id
    }
  }
  onCancel() {
    this.$emit('onCancel')
  }
  handleSubmit(e: any) {
    e.preventDefault()
    // console.log(this.item)
    const item: any = this.item
    const pdata = {
      student_id: item.id,
      class_id: this.classChoice
    }
    this.onOk(pdata)
  }
  async getAllClass() {
    try {
      const res = await getAllClass({})
      this.classList = res.data
    } catch (ex) {
      this.handleError(ex)
    }
  }
  async onOk(pdata: any) {
    try {
      const res = await removeStudent(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      this.$emit('onOk')
    } catch (ex) {
      this.handleError(ex)
    }
  }
}
